import { useQuery } from "@tanstack/react-query";
import { trainerFilesApi } from "api/trainers/trainerFilesApi";
import { QUERIES_KEYS } from "queries";

export const useTrainerFiles = (trainerId: number) => {
  return useQuery({
    queryKey: QUERIES_KEYS.TRAINER_FILES(trainerId),
    queryFn: () => trainerFilesApi.fetchFiles(trainerId),
    select: (res) => res.data,
  });
};
